import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: calc(100% - 55px);
  display: flex;
  align-items: center;
  justify-content: center;
`;
